(function(angular) {
    'use strict';

    angular.module('wtApp.dataService')
        .factory('WtAnalysisLive', ['WtAnalysis', function(WtAnalysis) {
            /**
             * @ngdoc service
             * @name WtAnalysisLive
             * @description Represents the live analyses
             */
            return class WtAnalysisLive extends WtAnalysis {
                constructor() {
                    super(...arguments);

                    // Adds older browsers support (IE < 11)
                    this.constructor = this.constructor || WtAnalysisLive;
                }
            };
        }]);
})(window.angular);
